import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@kuow/shared-ui';

export const RequireAuth: React.FC = () => {
  const { isAuthenticated, initialized } = useAuth();
  const location = useLocation();

  if (!initialized) {
    return (
      <Box w="full" py={{ base: 10, md: 16 }}>
        <Box w="full" maxW="480px" mx="auto" px={{ base: 4, md: 6 }}>
          <VStack align="center" gap={3}>
            <Spinner />
            <Text color="fg.muted">Checking your session…</Text>
          </VStack>
        </Box>
      </Box>
    );
  }

  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/sign-in" replace state={{ from }} />;
  }

  return <Outlet />;
};
